export const LOADING_IMPORT_TRANSACTIONS = 'LOADING_IMPORT_TRANSACTIONS'
export const LOADING_IMPORT_SINGLE_TRANSACTION = 'LOADING_IMPORT_SINGLE_TRANSACTION'

export const FETCH_LIST_TRANSACTIONS = 'FETCH_LIST_TRANSACTIONS'
export const LOADING_LIST_TRANSACTIONS = 'LOADING_LIST_TRANSACTIONS'

export const SELECT_TRANSFER_TRANSACTION = 'SELECT_TRANSFER_TRANSACTION'